import '../assets/styles/modalinfos.scss'
import error from '../assets/img/Icon awesome-exclamation-circle.svg'
import success from '../assets/img/Icon awesome-check-circle.svg'

export function ModalInfos(props) {

    return (
        <div id="modal-container">
            <input style={{display: 'none'}} type='checkbox' checked={props.checked} id='button' />
            <div className='modal'>
                <div className='content'>
                    <div>
                        <img src={props.error ? error : success} />
                        <h1 className='montserrat w600'>{props.label}</h1>
                        <h4 className='montserrat'>{props.sugestao}</h4>
                        <label onClick={props.onClick} for='button' className='montserrat w600 label2'>Okay</label>
                    </div>
                </div>
            </div>
        </div>
    )
}